import { DTOCreateDocumentationGroupInput, DTOCreateDocumentationTabInput, DTODeleteDocumentationGroupInput, DTODeleteDocumentationTabGroupInput, DTODuplicateDocumentationGroupInput, DTOMoveDocumentationGroupInput, DTOUpdateDocumentationGroupInput, } from "./group-v2";
import { z } from "zod";
//
// Read
//
const SuccessPayload = z.object({
    success: z.literal(true),
});
export const DTODocumentationGroupCreateActionOutputV2 = z.object({
    type: z.literal("DocumentationGroupCreate"),
    output: SuccessPayload,
});
export const DTODocumentationTabCreateActionOutputV2 = z.object({
    type: z.literal("DocumentationTabCreate"),
    output: SuccessPayload,
});
export const DTODocumentationGroupUpdateActionOutputV2 = z.object({
    type: z.literal("DocumentationGroupUpdate"),
    output: SuccessPayload,
});
export const DTODocumentationGroupMoveActionOutputV2 = z.object({
    type: z.literal("DocumentationGroupMove"),
    output: SuccessPayload,
});
export const DTODocumentationGroupDuplicateActionOutputV2 = z.object({
    type: z.literal("DocumentationGroupDuplicate"),
    output: SuccessPayload,
});
export const DTODocumentationGroupDeleteActionOutputV2 = z.object({
    type: z.literal("DocumentationGroupDelete"),
    output: SuccessPayload,
});
export const DTODocumentationTabGroupDeleteActionOutputV2 = z.object({
    type: z.literal("DocumentationTabGroupDelete"),
    output: SuccessPayload,
});
//
// Write
//
export const DTODocumentationGroupCreateActionInputV2 = z.object({
    type: z.literal("DocumentationGroupCreate"),
    input: DTOCreateDocumentationGroupInput,
});
export const DTODocumentationTabCreateActionInputV2 = z.object({
    type: z.literal("DocumentationTabCreate"),
    input: DTOCreateDocumentationTabInput,
});
export const DTODocumentationGroupUpdateActionInputV2 = z.object({
    type: z.literal("DocumentationGroupUpdate"),
    input: DTOUpdateDocumentationGroupInput,
});
export const DTODocumentationGroupMoveActionInputV2 = z.object({
    type: z.literal("DocumentationGroupMove"),
    input: DTOMoveDocumentationGroupInput,
});
export const DTODocumentationGroupDuplicateActionInputV2 = z.object({
    type: z.literal("DocumentationGroupDuplicate"),
    input: DTODuplicateDocumentationGroupInput,
});
export const DTODocumentationGroupDeleteActionInputV2 = z.object({
    type: z.literal("DocumentationGroupDelete"),
    input: DTODeleteDocumentationGroupInput,
});
export const DTODocumentationTabGroupDeleteActionInputV2 = z.object({
    type: z.literal("DocumentationTabGroupDelete"),
    input: DTODeleteDocumentationTabGroupInput,
});
